import { css } from '@emotion/react';

export const cardStyles = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: var(--spacing-8) var(--spacing-7);
  background-color: var(--surface-page);
  border: 1px solid var(--color-neutral-100);
  border-radius: var(--spacing-4);
  color: var(--color-primary-800);
`;

export const headerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-4);
`;

export const titleBlockStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  min-width: 0;
`;

export const changeButtonStyles = css`
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-primary-800);
  font: inherit;
  line-height: 1;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  cursor: pointer;
  appearance: none;

  &:hover {
    color: var(--color-primary-600);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
    border-radius: var(--radius-sm);
  }
`;

export const dividerStyles = css`
  width: 100%;
  height: 1px;
  margin: var(--spacing-3) 0 var(--spacing-5);
  border: 0;
  background-color: var(--color-neutral-100);
`;

export const listStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  margin: 0;
  padding: 0;
`;

export const rowStyles = css`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--spacing-4);

  > dt,
  > dd {
    margin: 0;
  }
`;

export const totalRowStyles = css`
  margin-top: var(--spacing-3);
`;

export const amountStyles = css`
  flex-shrink: 0;
  margin: 0;
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const footnoteStyles = css`
  margin-top: var(--spacing-6);
`;
